import $ from "jquery";
import moment from "moment";
import { Klass, u_ } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";
import "./assets/klass.VuwField";

/**
 * VuwPeriodField (extends VuwField)
 * @options
 * - {Boolean} required
 * - {Boolean} hasTime
 */
vuwer.appendKlass("VuwPeriodField", {
	inpType: "period",
	hasTime: false,
	timeInputType: "selector",	// "selector" | "picker"
	datePickerOption: {},
	defaultStartTime: "00:00",
	defaultEndTime: "23:59",
	
	_initialize(opt) {
		const _super_ = Klass("VuwPeriodField").parent._initialize.bind(this);
		if( !_super_(opt) ) {
			return false;
		}
		
		u_.isBoolean(this.hasTime) || (this.hasTime = false);
		
		this.childKlass = `Vuw${this.hasTime ? "Datetime" : "Date"}Field`;
		
		const { idPrefix, required, timeInputType, datePickerOption, mask } = this;
		
		this
		.add("start", {
			paramKey: `${this.paramKey}[start]`,
			idPrefix,
			required,
			timeInputType,
			datePickerOption,
			mask,
			defaultTime: this.defaultStartTime
		})
		.add("end", {
			paramKey: `${this.paramKey}[end]`,
			idPrefix,
			required,
			timeInputType,
			datePickerOption,
			mask,
			defaultTime: this.defaultEndTime
		});
		
		if(this.hasTime) {
			if( this.get("date.start") ) {
				this.get("date.start").pairField = this.get("date.end");
				this.get("date.end").pairField = this.get("date.start");
			}
		} else {
			this.get("start").pairField = this.get("end");
			this.get("end").pairField = this.get("start");
		}
		
		// [バリデーションの登録]
		const unitTxt = this.hasTime ? "日時" : "日";
		this.addValidation("compar", val => (
			!u_.isObject(val) ||
			!val.start ||
			!val.end ||
			!moment(val.start).isAfter(val.end)
		), `終了${unitTxt}は開始${unitTxt}より後になるように入力して下さい`);
		
		// [required, disabled, readonly の動的な切り替え用]
		this
		.onChangeState(state => {
			const methods = this.getChildren().map(vuwField => {
				if( vuwField instanceof Klass("VuwField") ) {
					return vuwField.setState(state);
				}
			});
			return $.when.apply($, methods);
		})
		.onChangeState(state => {
			if( state.hasOwnProperty("required") ) {
				this.required = !!state.required;
				delete state.required;
			}
			
			if( state.hasOwnProperty("disabled") ) {
				delete state.disabled;
			}
			
			if( state.hasOwnProperty("readonly") ) {
				delete state.readonly;
			}
		});
		
		return this;
	},
	
	getInpReady($self) {
		const childFieldType = this.hasTime ? "datetime" : "date";
		this.getChildren().forEach(vuwField => {
			( vuwField instanceof Klass("VuwField") ) && vuwField.renderField();
		});
		
		this.$inp = this.get("start").$inp.add( this.get("end").$inp );
		
		$self.on("change", `.field-${childFieldType}`, e => {
			const reg = new RegExp( RegExp.escape(`field-${childFieldType}`) );
			if( !reg.test(e.target.className) ) {
				return true;
			}
			
			this.setVal({
				start: this.get("start").getVal(),
				end: this.get("end").getVal()
			}, true);
		});
		
		return this.clearVal();
	},
	
	// [override]
	validate() {
		let err_cnt = 0;
		this.getChildren().forEach(vuwField => {
			if( vuwField instanceof Klass("VuwField") ) {
				vuwField.validate() || err_cnt++;
			}
		});
		
		if(!err_cnt) {
			const _super_ = Klass("VuwPeriodField").parent.validate.bind(this);
			_super_() || err_cnt++;
		}
		
		return !err_cnt;
	},
	
	setVal(value, withoutChildren, antiTriggerChange) {
		if( u_.isObject(value) ) {
			if( u_.isString(value.start) && value.start ) {
				(value.start.indexOf("T") < 0) && (value.start += "T00:00");
				moment(value.start).isValid() || (value.start = "");
			} else {
				value.start = "";
			}
			if( u_.isString(value.end) && value.end ) {
				(value.end.indexOf("T") < 0) && (value.end += "T23:59");
				moment(value.end).isValid() || (value.end = "");
			} else {
				value.end = "";
			}
		} else {
			value = { start: "", end: "" };
		}
		
		this.get("start").setVal(value.start, withoutChildren, antiTriggerChange);
		this.get("end").setVal(value.end, withoutChildren, antiTriggerChange);
		
		return this;
	},
	
	getVal() {
		return {
			start: this.get("start").getVal(),
			end: this.get("end").getVal()
		};
	},
	
	_getCopiedInp() {
		const clones = [];
		
		const $start = this.get("start").getCopiedElement();
		!!$start && clones.push( $start );
		
		const $end = this.get("end").getCopiedElement();
		
		if($start || $end) {
			clones.push( $("<span/>").addClass("period-splitter") );
		}
		
		!!$end && clones.push( $end );
		
		return clones;
	},
	
	_renderField() {
		const $start = $("<var/>");
		const $end = $("<var/>");
		const elms = [
			$start,
			$("<span/>").addClass("period-splitter"),
			$end
		];
		
		this.get("start").$self = $start;
		this.get("end").$self = $end;
		
		return $.fn.append.apply(
			$("<div/>").addClass("vuw-field field-period").attr({
				"id": `field_${this.idStr}`,
				"data-name": this.paramKey
			}),
			elms
		);
	}
}, "VuwField");
